import { render, staticRenderFns } from "./baseNews.vue?vue&type=template&id=189264f6&scoped=true&"
import script from "./baseNews.vue?vue&type=script&lang=js&"
export * from "./baseNews.vue?vue&type=script&lang=js&"
import style0 from "./baseNews.vue?vue&type=style&index=0&id=189264f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189264f6",
  null
  
)

export default component.exports